import { useMemo } from 'react';
import { useReactiveVar } from '@apollo/client';

import { checkAnswerVar } from './check-answer.apollo';

export const useCheckAnswer = ({ componentId }: { componentId: string }) => {
  const checkAnswerData = useReactiveVar(checkAnswerVar);
  const currentAnswerData = useMemo(
    () => checkAnswerData[componentId],
    [checkAnswerData, componentId]
  );

  return {
    checkAnswerData,
    currentAnswerData,
    hasAnswered: !!currentAnswerData?.hasChecked,
  };
};
